import { render, staticRenderFns } from "./idScanner.template.vue?vue&type=template&id=5c28baa1&scoped=true&"
var script = {}
import style0 from "./idScanner.template.vue?vue&type=style&index=0&id=5c28baa1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c28baa1",
  null
  
)

export default component.exports